export enum LayoutKind {
  BoxedLayout = 0,
  ScrollLayout = 1
}
